import { GetServerSideProps } from 'next'
import RecoverPassword from 'components/auth/RecoverPassword'

interface IProps {
  email: string
}

function RecoverPasswordPage(pageProps: IProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-1 items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <RecoverPassword email={pageProps.email} />
      </div>
    </div>
  )
}

export default RecoverPasswordPage

export const getServerSideProps: GetServerSideProps<IProps> = async context => {
  const email = context.query.email! as string

  return {
    props: {
      email: email || process.env.DEFAULT_LOGIN_USER || ''
    }
  }
}
